import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCart, ArrowRight } from 'lucide-react';
interface StickyMobileCTAProps {
  onCheckoutAttempt: () => void;
  itemCount: number;
  total: number;
}
export function StickyMobileCTA({
  onCheckoutAttempt,
  itemCount,
  total
}: StickyMobileCTAProps) {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past the hero section (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-942">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-0 left-0 right-0 z-40 p-4 bg-white/90 backdrop-blur-md border-t border-ink/10 shadow-[0_-10px_40px_rgba(0,0,0,0.05)] md:hidden" data-id="element-943">
          <div className="flex items-center justify-between gap-4 max-w-7xl mx-auto" data-id="element-944">
            <div className="flex flex-col" data-id="element-945">
              <span className="text-xs font-bold text-ink-light uppercase tracking-wider" data-id="element-946">
                {itemCount > 0 ? 'Tu total' : 'Desde'}
              </span>
              <span className="text-xl font-extrabold text-ink" data-id="element-947">
                ${itemCount > 0 ? total.toLocaleString('es-AR') : '14.990'}
              </span>
            </div>
            <button onClick={itemCount > 0 ? onCheckoutAttempt : () => document.getElementById('kits')?.scrollIntoView({
          behavior: 'smooth'
        })} className="flex-1 bg-combo-green text-white px-6 py-3.5 rounded-full font-bold text-sm flex items-center justify-center gap-2 shadow-glow active:scale-95 transition-transform" data-id="element-948">
              {itemCount > 0 ? <>
                  FINALIZAR COMPRA <ArrowRight className="w-4 h-4" data-id="element-949" />
                </> : <>
                  ELEGIR KIT <ShoppingCart className="w-4 h-4" data-id="element-950" />
                </>}
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}